/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function EDAsFormsAndHandbooksInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="EDA Handbooks & Forms"
              description={
                <>
                  <h3>Guides for The Official Agent of An Electoral District Association</h3>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><p><a href="/files/Forms&Handbooks/EDAs/Contributions and Fundraising Guide_ Final.pdf">Contributions and Fundraising Guide</a></p></li>
                  </ul>
                  <br />
                  <h3>Handbooks &amp; Forms</h3>

                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/Forms&Handbooks/EDAs/NS%202015%20Auditors-Guide%20Sept%202%202015_0.pdf">Nova Scotia Auditor&#39;s Guide</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/EDAOfficialHandbookFebruary2017.pdf">Handbook for the Official Agent of an Electoral District Association</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-0RegistrationOfElectroalDistrictAssociation.pdf">Form 4-0, Registration of an Electoral District Association</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4_1_RenewalofEDARegistration_2023.pdf">Form 4-1, Renewal of an Electoral District Association</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-1A_EDANoticeOfRefusalToRegister.pdf">Form 4-1A, Notice of Refusal to Register an Electoral District Association</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-2EDA_EDAUpdate.pdf">Form 4-2, Electoral District Association Update Information</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/EDA_ReportingWorkbook_2026February03.xlsx">EDA Reporting Workbook</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form_4_3_EDAStatementofIncomeandExpenses_2023.pdf">Form 4-3, Financial Report of an Electoral District Association, Statement of Income and Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-3A_EDAStatementOfMonetaryContributions.pdf">Form 4-3A, Financial Return for an Electoral District Association, Statement of Monetary Contributions and Fundraising Events</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form_4_3B_EDAStatementofDonationsinKind_2023.pdf">Form 4-3B, Financial Return for an Electoral District Association, Statement of Donations in Kind</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-3C_EDAStatementOfTransfers.pdf">Form 4-3C, Financial Return for an Electoral District Association, Statement of Transfers to and from Registered Party and Candidate</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-3D_EDAStatementOfLoanOrLineOfCredit.pdf">Form 4-3D, Financial Return for an Electoral District Association, Loan and Line of Credit</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form4-3E_SummaryOfExpenses.pdf">Form 4-3E, Financial Return for an Electoral District Association, Summary of Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form_4_4_EDABalanceSheet_2023.pdf">Form 4-4, Financial Return for an Electoral District Association, Electoral District Association Balance Sheet</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form 5, Statement of Fundraising Event Revenue and Expenses.pdf">Form 5, Statement of Fundraising Revenue and Expenses</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form5-1SummaryOfFundraisingFunctions.pdf">Form 5-1, Statement of Fundraising Part 2, Summary of Fundraising Functions</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form8-1ReturnOfContribution.pdf">Form 8-1, Return of Contribution</a></li>
                    <li><a href="/files/Forms&Handbooks/EDAs/Form8-2ApprointmentOfIndividualToAcceptContribution.pdf">Form 8-2, Appointment of Individual to Accept Contribution</a></li>
                  </ul>


                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default EDAsFormsAndHandbooksInformation;
